module.exports = __webpack_public_path__ + "img/icon-mts.1f6a8037.svg";